import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconLogoWisniowskiSmall } from '../../../../../../../assets/logo-icons/icon-logo-wisniowski-small';
import { Header, NavHeader, Page, SubmitButton } from '../../../../../../../components';
import { ROUTES } from '../../../../../../../routes/routes';
import { useBluetoothContext } from '../../../context';
import { DriveFlowType } from '../../../types';
import './index.scss';

const WisniowskiDriveAddTutorialStep1: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('drive-add');
  const { checkIfConnected } = useBluetoothContext();

  useEffect(() => {
    checkIfConnected();
  }, []);

  const handleNext = () => {
    navigate(ROUTES.DeviceAddBluetoothWisniowskiTutorialStep2(DriveFlowType.Drive));
  };

  return (
    <Page
      contentClassName="drive-add tutorial"
      containerClassName="p-t-0"
      isStickyHeader
      header={
        <>
          <NavHeader title={t('navbarHeader')} />
        </>
      }
    >
      <div className="tutorial--content">
        <Header title={t('tutorial.case')} center />
        <img src="/images/drive-case.png" alt="drive-case" />
        <IconLogoWisniowskiSmall className="m-t-48" />
        <SubmitButton onClick={handleNext}>{t('tutorial.nextStep')}</SubmitButton>
      </div>
    </Page>
  );
};

export default WisniowskiDriveAddTutorialStep1;
